<template>
    <svg width="104" height="75" viewBox="0 0 104 75" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3.34619 3.3457H14.5348C16.9566 3.3457 19.1839 4.67774 20.3299 6.81068L41.5214 46.2596C43.0376 49.0826 45.9822 50.8433 49.1862 50.8433H85.7678L100.656 13.3789H23.8559"
            stroke="#C43A4F" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M43.9096 71.6542C47.3054 71.6542 50.0582 68.9017 50.0582 65.5063C50.0582 62.1109 47.3054 59.3584 43.9096 59.3584C40.5139 59.3584 37.7611 62.1109 37.7611 65.5063C37.7611 68.9017 40.5139 71.6542 43.9096 71.6542Z"
            stroke="#C43A4F" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M85.7552 71.6542C89.1509 71.6542 91.9037 68.9017 91.9037 65.5063C91.9037 62.1109 89.1509 59.3584 85.7552 59.3584C82.3595 59.3584 79.6067 62.1109 79.6067 65.5063C79.6067 68.9017 82.3595 71.6542 85.7552 71.6542Z"
            stroke="#C43A4F" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
        <path opacity="0.2"
            d="M98.0126 13.377H85.8682C85.8682 24.0249 81.5308 33.6608 74.5917 40.6472C67.6046 47.5855 57.9677 51.9225 47.3186 51.9225H82.5911L98.0105 13.377H98.0126Z"
            fill="#C43A4F" />
    </svg>
</template>